import request from '@/utils/request';
/**
 ** 基地接口
 **/

/**
 * @describe 新增基地
 * @param entId 企业id
 * @param baseCode 基地编号
 * @param baseName 基地名称
 * @param baseAddr 基地地址
 * @param scaleVal 基地规模
 * @param scaleValUnit 基地规模单位
 * @param lat 纬度
 * @param lng 经度
 * @param image1
 * @param image2
 * @param image3
 * @param headImg 头像图片
 * @param baseTypeId 基地类别id
 * @param areaPoints 地区轮廓
 */
export function saveEnterpriseProductionBase(query) {
  return request({
    url: 'basic/saveEnterpriseProductionBase.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 修改基地
 * @param entProdBaseId
 * @param 同上
 */
export function editEnterpriseProductionBase(query) {
  return request({
    url: 'basic/editEnterpriseProductionBase.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 删除一个基地
 * @param entProdBaseId
 */
export function delEnterpriseProductionBase(query) {
  return request({
    url: 'basic/delEnterpriseProductionBase.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 激活/停用 一个基地
 * @param entProdBaseId
 * @param isStoped 是否停用 1-是 0-否
 */
export function stopOrActiveEnterpriseProductionBase(query) {
  return request({
    url: 'basic/stopOrActiveEnterpriseProductionBase.do',
    method: 'POST',
    data: query
  })
}



/**
 * @describe 获取一个基地
 * @param entProdBaseId
 */
export function getOneEnterpriseProductionBase(query) {
  return request({
    url: 'basic/getOneEnterpriseProductionBase.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 分页查看基地
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param isStoped 是否停用 1-是 0-否
 * @param baseName
 * @param baseCode
 * @param entName
 * @param pageNum
 * @param pageSize
 */
export function pageEnterpriseProductionBase(query) {
  return request({
    url: 'basic/pageEnterpriseProductionBase.do',
    method: 'GET',
    params: query
  })
}

